var _defs, _rect, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _ellipse, _ellipse2, _rect2, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse3, _path22, _path23, _g, _polygon, _polygon2, _polygon3, _path24, _path25, _path26, _line, _line2, _circle, _circle2, _path27, _path28, _path29, _path30, _polyline, _g2, _path31, _path32, _path33, _path34, _path35, _g3, _g4, _path36, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingstrategyplanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9292b7;}.cls-12,.cls-14,.cls-2,.cls-21,.cls-22,.cls-23,.cls-24,.cls-27,.cls-31,.cls-35,.cls-8{fill:none;}.cls-3{fill:#d8c4df;}.cls-4{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4,.cls-5{fill:#2f2143;}.cls-6{fill:#f37c7d;}.cls-7{fill:#9a499c;}.cls-12,.cls-8{stroke:#000;}.cls-12,.cls-14,.cls-8{stroke-linecap:round;}.cls-12,.cls-14,.cls-21,.cls-22,.cls-23,.cls-24,.cls-27,.cls-31,.cls-35,.cls-8{stroke-miterlimit:10;}.cls-8{stroke-width:1.55px;}.cls-9{fill:#f2efef;}.cls-10{fill:#54478d;}.cls-11{fill:#7467ae;}.cls-12{stroke-width:1.47px;}.cls-13{fill:#5eb0a2;}.cls-14{stroke:#191847;stroke-width:0.74px;}.cls-15{clip-path:url(#clip-path);}.cls-16{fill:#32326b;}.cls-17{fill:#ffd664;}.cls-18{fill:#e5ac24;}.cls-19{fill:#cd922a;}.cls-20{fill:#fff;}.cls-21,.cls-22,.cls-35{stroke:#fff;}.cls-21{stroke-width:0.5px;}.cls-22{stroke-width:2.76px;}.cls-23{stroke:#2f2143;stroke-width:2px;}.cls-24{stroke:#1f3242;stroke-width:1.04px;}.cls-25{fill:#1f3242;}.cls-26{fill:#386994;}.cls-27{stroke:#e5ac24;stroke-width:1.71px;}.cls-28{opacity:0.5;}.cls-29{clip-path:url(#clip-path-2);}.cls-30{fill:#2e1f42;}.cls-31{stroke:#4f4e4f;stroke-width:1px;}.cls-32{clip-path:url(#clip-path-3);}.cls-33{fill:#eae6e1;}.cls-34{clip-path:url(#clip-path-4);}.cls-35{stroke-width:1.04px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.71,121.21A39.12,39.12,0,1,1,327.6,82.1,39.11,39.11,0,0,1,366.71,121.21Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1138.18,
    y: 213.15,
    width: 47.35,
    height: 41.8,
    transform: "translate(402.19 1143.77) rotate(-61.53)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1156.15,
    y: 211.06,
    width: 9.57,
    height: 10.19,
    transform: "translate(417.44 1133.59) rotate(-61.53)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1153.96,
    y: 209.5,
    width: 13.41,
    height: 14.28,
    transform: "translate(416.87 1133.61) rotate(-61.53)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BRANDING STRATEGY &amp;amp; PLANNING") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(447.18 157.29)"
  }, "BRANDING STRATEGY ", /*#__PURE__*/React.createElement("tspan", {
    x: 153.3,
    y: 75
  }, "&amp; PLANNING"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1375,77.53c-2.94-11.09-1.41-24.15,23.39-35.68s72.67-6.53,81.81,31.55-.87,57.44,17.62,81.37,52.65,51.78,23.06,84.64C1470,275.3,1387.49,234,1380.09,214s4.35-52,21.33-78.76S1378.13,94.72,1375,77.53",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1284.61,226l-1.83-6.46a6,6,0,0,1-6.36-.19s-7.24,2.7-11.48-3.76c0,0-4,2.83-10.16-.7,0,0-5.2-3.16-3.09-5.43,0,0,1.59-1.64,10.46,2.08,0,0-1.73-8.29,1.08-8.8,0,0,3-.64,7.15,7.41,0,0-.37-7.18,2.33-6.6s5.74,7.14,6.6,9.34l2.5-.68s-3-8.65.56-9c0,0,3.41-1.68,7.06,8l7.93-2s6-2.2,8.33,3l3.6,8.54S1305,235.26,1284.61,226Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.83,169.48l.1-41.31s11.57,5.44,17.77-6.57c0,0,6.65-13.4-8.23-15.75,0,0-3.19-.65-7.9,2.6,0,0,5.45-33.65-11.09-44s-60.93-12.65-68.89,21.78c0,0,1.06,4.37,1.64,8.8s1,16.55.55,27.54,7.34,25.71,17.73,30,15.63,3.1,21.77,1.91c0,0,1.54,19.51,2.22,22.86l34.43-2.2Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1473.17,178.71s-18.23-.74-16.15-5.29c0,0,.28-13.72-5-9.14s-25,3.79-33,1.91c0,0-2.64-2.95.34,11.56,0,0,1,.78-11.21,2.48C1408.16,180.23,1430.71,207,1473.17,178.71Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1376.52,86.1c4.14-8.7,27.63-21.54,39.38-23.06,5,29.8,12.51,47.43,28.83,43.73,3.7,15.88,4.9,15.66,7.29,14.79s3.7-9.46,4.35-13.81c7.4-5.44,11.31-13.82,10.44-26.22s-11.31-38.95-45.9-32.64-49.39,18.72-44.39,37.21",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1282,224.77s16,5.6,28.42-5.88c0,0,4,6.25,23.36,45.69,0,0,18.17-36,22.72-48.94,0,0,11.64-31.89,28.45-33.66,0,0,19.75-.54,23.88-1.09,0,0,18.61,22.85,63.88-1.44,0,0,24.18,2.31,35.41,17.87,0,0,9.29,12.19,25.25,53.57,0,0,17.92,46,21.26,57.5a39.84,39.84,0,0,1,0,18.2l-40-.44s7.86-5.94-17.85-58.09l-.87,58.09h-98.34l-13.92-70.27s-10.68,25-15.38,32.92c0,0-14.6,27.23-26,28.66,0,0-17.3,6.68-31.89-14.37C1310.24,303.09,1276.72,223,1282,224.77Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1384.91,95.54s3.35-4.25,8.51,0",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1407,96.49s7.19-5.15,12,2",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1396.16,104.52l-2.9,10.64a2.85,2.85,0,0,0,3.58,3.48l3.57-1.08",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1401.42,134.33s13.14,8.1,19.83-6.28",
    transform: "translate(0 0)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1412.99,
    cy: 106.71,
    rx: 1.67,
    ry: 3.11,
    transform: "translate(48.66 489.51) rotate(-19.99)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1387.27,
    cy: 106.71,
    rx: 1.67,
    ry: 3.11,
    transform: "translate(47.11 480.71) rotate(-19.99)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1256.71,
    y: 136.65,
    width: 54.85,
    height: 55.36,
    rx: 9.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1275.32,179.22a4.44,4.44,0,1,1-8.88,0v-19a4.44,4.44,0,1,1,8.88,0Z",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1287.72,179.22a4.44,4.44,0,1,1-8.88,0V153.15a4.44,4.44,0,0,1,8.88,0Z",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1300.11,179.22a4.44,4.44,0,1,1-8.87,0V146.71a4.44,4.44,0,1,1,8.87,0Z",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.09,210.94l12.37-15.68s4.71-4.7,11.31-4.31,16.6.55,20.84-6.13c0,0,8.94-13.6,5.17-15.73,0,0-2.46-1.21-6.56,3,0,0,1.13-3.69-1.23-4.46s-4.73,4.19-5,4.28c0,0-1.07-4.22-3.28-2.4,0,0-2.64,1.49-3.53,8.59a3.49,3.49,0,0,0-4.72-1S334.92,180,319,181.2a18.75,18.75,0,0,0-9.35,5.66l-8,9.43Z",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.31,178.65s2.72-15.71,4.74-16.5,29.89,4.53,30.62-14.07c0,0,.54-11.26,5.9-12.34,0,0,7.8-4.42,1.82-10.24,0,0-7-5.7-6.32-10.78,0,0,5.75-23.47-2.93-33.23,0,0-34.46-26-52.32-4.4s-24.65,16.2-9.15,74.33l-2.31,15.71,7.86,8.29Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M208.55,326.52s-2.21-40.53,5.75-43.13c0,0,14.4-11.14,14.54-14.79,0,0,14.34,15.62,22.39,15.68,0,0,12.5,2.91,25-11,0,0,39.19-44.75,47.59-58,0,0,4.35-5.27-1.75-9.61l-18.09-13s-3.73-5.42-9.71,2.48c0,0-27.46,36.67-28.06,37.28s-7,8-17-7c0,0-22.24-30.34-28.15-32.8l4.75-16.38s1.33-2.53-3.35-3.62S196.32,165,196.32,165s-4-2.14-4.66,2.87-4.69,15.42-6.94,16.51-20.95,33.75-22.57,43.06c0,0-17.85,48.68-29.52,98.7Z",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.84,268.6s-26.86-26-27.72-39",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.93,81.31s-1.06,6.48-22.61,4.82c0,0-8.56.45-3.44,11.29,0,0,7.47,26-4.55,30.33,0,0-2.42,1.19-6.11-6,0,0-4-7.42-9.05-5.82,0,0-13,5.07-5.4,20,0,0-4.52,16.53-10.62,15.68,0,0-29.6-20.92-26.2-47.13S196.64,67.15,203.6,65.3s25.27-6.94,45.17,2.31C248.77,67.61,262.74,74.13,260.93,81.31Z",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.41,87.51s-8.87,2.6-7.55,25.82c0,0,2.32,24.84,9.52,44.77,0,0,8.75,28.56-23.42,27.49,0,0,3.11,24.72-19.49,30.26,0,0-26.17,4.34-26.12-14.51,0,0-22.79,6-17.7-25,0,0,.52-6.12,5.39-14.84s20-46.48,20.48-52.28S128,31.87,179.36,77.18v6.56Z",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M176.58,90.21s-3.39-.56-3-5.32,4.65-9.84,7.11-9.8c0,0,3.25-.53,6.57,3.1C187.29,78.19,183.39,92.89,176.58,90.21Z",
    transform: "translate(0 0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M209.77,136s5,8.68,10.07,5.8",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M260,145.47s-7.18,2.66-11-9.5",
    transform: "translate(0 0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.19,110a.58.58,0,0,1-.46-.22.6.6,0,0,1,.08-.85,26.87,26.87,0,0,0,2.68-3.14.6.6,0,1,1,1,.72,29.62,29.62,0,0,1-2.88,3.35.57.57,0,0,1-.39.14",
    transform: "translate(0 0)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 253.91,
    cy: 112,
    rx: 3.52,
    ry: 1.66,
    transform: "translate(56.97 307.52) rotate(-68.6)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M250.66,104.18s4-7.87,9.3-3.65",
    transform: "translate(0 0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.71,121.21A39.12,39.12,0,1,1,327.6,82.1,39.11,39.11,0,0,1,366.71,121.21Z",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "327.6 121.21 301.64 84.52 334.18 75.65 327.6 121.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "327.6 121.68 332.76 77.03 362.91 92.14 327.6 121.68"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "501.22 275.38 559.87 285.09 536.92 307.41 501.22 275.38"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "501.22 275.38 548.26 296.54 550.58 307.24 553.07 293.36 501.22 275.38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "542.73 300.2 550.58 307.24 548.26 296.54 542.73 300.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M62.77,272.55a5.51,5.51,0,1,1,1.71,7.6,5.51,5.51,0,0,1-1.71-7.6",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M58,244.31a5.51,5.51,0,1,1,1.71,7.6,5.52,5.52,0,0,1-1.71-7.6",
    transform: "translate(0 0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M37.83,271.17a5.51,5.51,0,1,1-1.09,7.72,5.5,5.5,0,0,1,1.09-7.72",
    transform: "translate(0 0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 61.92,
    y1: 275.46,
    x2: 46.59,
    y2: 275.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 68.75,
    y1: 270.15,
    x2: 64.24,
    y2: 251.95
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 1558.43,
    cy: 88.59,
    r: 15.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 375.5,
    cy: 275.46,
    r: 15.93
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.79,18.74H417.05a4.83,4.83,0,0,0-4.83,4.83V46.9a4.82,4.82,0,0,0,4.83,4.82h4.07c.3,1.57.49,5.79-5.09,8.73,0,0,14.63-.71,14.84-8.73h35.92a4.82,4.82,0,0,0,4.82-4.82V23.57a4.82,4.82,0,0,0-4.82-4.83",
    transform: "translate(0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1297.06,55.27a10.21,10.21,0,0,1,2,12.14,10.35,10.35,0,0,1-1.65,2.3,11.1,11.1,0,0,1-1.22,1.08,10.21,10.21,0,1,1,.9-15.52Z",
    transform: "translate(0 0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1299.14,67.44l11.73,11.23a2.24,2.24,0,1,1-3.1,3.24l-11.46-11",
    transform: "translate(0 0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1310.24,79.68a1.08,1.08,0,0,1-1.49,1.55,1.08,1.08,0,0,1,1.49-1.55",
    transform: "translate(0 0)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "1012.22 292.89 1029.23 304.78 1036.76 285.45 1053.77 297.34 1061.31 278 1078.32 289.89"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1181.55,241.57c-.89,1.69-3.42,6.51-8.39,8.41-2.71,1-4.64.63-7.88,2.49s-3,3.32-5.19,4.16c-5.09,2-13.86-3-15-8.83-.47-2.3.59-3,0-6.73-.51-3.48-1.74-4.83-2.42-7.18-1.56-5.4,1.34-10.76,2.14-12.25,4.3-7.95,17.08-14.5,28.34-8.4s12.56,20.41,8.4,28.33",
    transform: "translate(0 0)"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1181.55,241.57c-.89,1.69-3.42,6.51-8.39,8.41-2.71,1-4.64.63-7.88,2.49s-3,3.32-5.19,4.16c-5.09,2-13.86-3-15-8.83-.47-2.3.59-3,0-6.73-.51-3.48-1.74-4.83-2.42-7.18-1.56-5.4,1.34-10.76,2.14-12.25,4.3-7.95,17.08-14.5,28.34-8.4s12.56,20.41,8.4,28.33",
    transform: "translate(0 0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1157.62,258.69l-13.18-7.15a2.78,2.78,0,0,1,2.65-4.88l13.18,7.14a2.78,2.78,0,0,1-2.65,4.89",
    transform: "translate(0 0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1154.48,265.53l-13.37-7.25a2.67,2.67,0,1,1,2.55-4.69l13.36,7.25a2.67,2.67,0,1,1-2.54,4.69",
    transform: "translate(0 0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1150.44,272.14l-12.66-6.87a3.07,3.07,0,0,1,2.93-5.4l12.66,6.87a3.07,3.07,0,0,1-2.93,5.4",
    transform: "translate(0 0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1151,248.78s6.16-8.89,6.23-12.57-4.87.29-2.86,1.72a5.83,5.83,0,0,0,6.39,0c2-1.11.59-5.17-.72-2s2.52,4.92,3.6,5.66,3.09-5.15.65-3.65-2,3.08-2.33,5.11-4.65,9.12-4.65,9.12",
    transform: "translate(0 0)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1166.81,214.81c.44,1.89-1.85,4-5.09,4.77s-6.24-.19-6.67-2.09,1.85-4,5.1-4.77,6.23.19,6.66,2.09",
    transform: "translate(0 0)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1168.91,214.76c.61,2.65-2.59,5.65-7.15,6.69s-8.73-.27-9.34-2.92,2.59-5.66,7.14-6.7,8.74.27,9.35,2.93",
    transform: "translate(0 0)"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1144.71,276.74l-6.8-3.68a3.31,3.31,0,0,1-1.33-4.48l.7-1.3a3.31,3.31,0,0,1,4.48-1.33l6.8,3.69a3.31,3.31,0,0,1,1.33,4.48l-.7,1.29a3.31,3.31,0,0,1-4.48,1.33",
    transform: "translate(0 0)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1189.59,
    y1: 222.27,
    x2: 1199.52,
    y2: 220.97
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1177.85,
    y1: 211.88,
    x2: 1182.62,
    y2: 203.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1165.29,
    y1: 206.72,
    x2: 1165.47,
    y2: 196.71
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1152.48,
    y1: 209.36,
    x2: 1147.24,
    y2: 200.82
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1143.56,
    y1: 217.4,
    x2: 1134.76,
    y2: 212.63
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1139,
    y1: 227.92,
    x2: 1128.99,
    y2: 227.79
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1186.99,
    y1: 235.84,
    x2: 1195.61,
    y2: 240.94
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 1181.77,
    y1: 248.41,
    x2: 1187.76,
    y2: 256.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingstrategyplanning);
export default __webpack_public_path__ + "static/media/BRANDING STRATEGY & PLANNING.c8c06424fdfaeac10fe4744db7c3a5b3.svg";
export { ForwardRef as ReactComponent };